import {PostCorrectiveTaxDocumentForCreatingApiResponse} from '@dms/api/sales';
import {AdditionalFieldsKeys, AdditionalFieldsValueTypes} from '@dms/api/shared';

import {AccountingDocumentFormValues} from '../../../types';

export const mapCustomFields = (
  data: NonNullable<PostCorrectiveTaxDocumentForCreatingApiResponse>['customFields'] | undefined
): AccountingDocumentFormValues['customFieldsPayload'] =>
  data?.map((field) => ({
    definitionId: field.definitionId as AdditionalFieldsKeys,
    value: {
      type: field.value?.type as AdditionalFieldsValueTypes,
      value: field.value?.value,
    },
  }));
